import DialogWrapper2 from '../core/dialog/dialog_wrapper_v2';
import { InfoDialog } from './InfoDialog';
import * as React from 'react';

interface LoginBestimmungenProps extends React.ClassAttributes<any> {
    onChange: (allChecked: boolean) => void;
}

interface LoginBestimmungenState extends React.ClassAttributes<any> {
    showInfo: string;
    cbNB: boolean;
    cbDS: boolean;
    cbKA: boolean;
}

export class LoginBestimmungen extends React.Component<LoginBestimmungenProps, LoginBestimmungenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showInfo: null,
            cbNB: false,
            cbDS: false,
            cbKA: true
        };
    }

    onchange(): void {
        const { cbNB, cbDS, cbKA } = this.state;
        this.props.onChange(cbNB && cbDS && cbKA);
    }

    render(): JSX.Element {
        const { cbNB, cbDS, cbKA } = this.state;

        const styleCb: React.CSSProperties = { marginRight: 10 };
        const styleBDiv: React.CSSProperties = {
            display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '5px 0', borderBottom: '1px solid #918f8f'
        };
        const styleStern: React.CSSProperties = {
            color: 'red', fontSize: 20, fontWeight: 'bold', cursor: 'help', verticalAlign: 'sub', lineHeight: '10px'
        };
        const styleLink: React.CSSProperties = { cursor: 'pointer' };

        return (
            <div>
                <div style={styleBDiv}>
                    <input
                        type='checkbox' style={styleCb} checked={cbNB}
                        onChange={(e) => this.setState({ cbNB: e.target.checked }, this.onchange)}
                    />
                    <div>
                        Ich habe die <a style={styleLink} onClick={() => this.setState({ showInfo: 'Nutzungsbedingungen' })}>Nutzungsbedingungen</a>&nbsp;
                        gelesen und akzeptiere sie&nbsp;&nbsp;
                        {!cbNB && <span style={styleStern} title='Bitte akzeptieren Sie die Nutzungsbedingungen !'>*</span>}
                    </div>
                </div>
                <div style={styleBDiv}>
                    <input
                        type='checkbox' style={styleCb} checked={cbDS}
                        onChange={(e) => this.setState({ cbDS: e.target.checked }, this.onchange)}
                    />
                    <div>
                        Ich habe die <a style={styleLink} onClick={() => this.setState({ showInfo: 'Datenschutz' })}>Datenschutzhinweise</a>&nbsp;
                        gelesen und akzeptiert&nbsp;&nbsp;
                        {!cbDS && <span style={styleStern} title='Bitte akzeptieren Sie die Datenschutzhinweise !'>*</span>}
                    </div>
                </div>
                {/*
                <div style={styleBDiv}>
                    <input
                        type='checkbox' style={styleCb} checked={cbKA}
                        onChange={(e) => this.setState({ cbKA: e.target.checked }, this.onchange)}
                    />
                    <div>
                        Ich bin damit einverstanden, dass mich die Mittelstandsinitiative Energiewende und Klimaschutz&nbsp;
                        per E-Mail kontaktiert, um die Reichweite der Verwendung des E-Tools zu erfassen. Dieses Einverständnis&nbsp;
                        kann ich jederzeit widerrufen per E-Mail an xxx@xxxxxx.xx&nbsp;&nbsp;
                        {!cbKA && <span style={styleStern} title='Bitte akzeptieren Sie das Einverständnis !'>*</span>}
                    </div>
                </div>
                */}
                {this.state.showInfo && this.renderInfo()}
            </div>
        );
    }

    renderInfo(): JSX.Element {
        const { showInfo: name } = this.state;

        return (
            <DialogWrapper2
                title={name || ''}
                width={880}
                onAfterClose={() => this.setState({ showInfo: null })}
            >
                <InfoDialog name={name} />
            </DialogWrapper2>
        );
    }
}
